export const currentColorOptions = ['primary', 'secondary', 'info', 'success', 'warning', 'danger'];
const currentColorMapping = {
    primary: '--brand-primary',
    secondary: '--brand-secondary',
    info: '--brand-info',
    success: '--brand-success',
    warning: '--brand-warning',
    danger: '--brand-danger',
};
export const getCurrentBackgroundColor = (color) => `var(${currentColorMapping[`${color}`]})`;
